import { Point } from '../../../platform/geom/Point';
import { Rect } from '../../../platform/geom/Rect';
import { TextAlignment, TextSettings } from '../../canvas/entities/TextConventions';
import { TextRuler } from '../../canvas/visualization/TextRuler';
import { CommentCountAttr, CommentOpenAttr } from '../annotations/CommentAssociations';
import { Tag } from '../annotations/Tag';
import { LtrTagLayout, TagLike } from '../annotations/TagLayout';
import { RoadmapCard } from './RoadmapCard';

const labelLayout = (object: RoadmapCard, area: Rect, metaHeight: number) => {

    const baseSettings = TextSettings.from({
        fontColor: object.getPreferredTextColor(),
        fontFamily: 'Rubik',
        fontSize: 0,
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: 1.25,
        maxFontSize: 24,
        textMargin: [5, 20, metaHeight, 20],
        textAlignH: TextAlignment.start,
        textAlignV: TextAlignment.middle,
    });

    const fontSize = Math.min(
        baseSettings.maxFontSize,
        (TextRuler.fit(object.label, baseSettings, area.width, area.height)),
    );

    return {
        bounds: area,
        settings: { ...baseSettings, fontSize },
    };
};

// export const RoadmapCardLayout = (card: RoadmapCard) => {
//     const { width, height } = card;

//     const base = new Rect(0, 0, width, height);
//     const badges = [] as TagLike[];

//     if (CommentCountAttr.get(card) > 0 || CommentOpenAttr.get(card)) {
//         badges.push({
//             id: 'comments',
//             text: (CommentCountAttr.get(card) || 0).toString(),
//             icon: true,
//         });
//     }

//     if (VoteCountAttr.get(card) > 0) {
//         badges.push({
//             id: 'votes',
//             text: `+${VoteCountAttr.get(card)}`,
//         });
//     }

//     const tags = TagLayout([...badges, ...Tag.sort(card.polarize(Tag))], base);


//     const title = titleLayout(card, base);
//     const content = contentLayout(card, base, title.bounds.height, tags.all.height);

//     return Object.freeze({ width, height, title, content, tags });
// };

// export type RoadmapCardLayout = ReturnType<typeof RoadmapCardLayout>;

export const RoadmapCardLayout = (card: RoadmapCard) => {
    const { width, height } = card;

    // const m1 = 10;
    // const m2 = m1 * 1.5;

    const base = new Rect(0, 0, width, height);

    const mark = base.set({
        left: card.marker,
        width: base.width - card.marker,
    });

    const original = base.set({
        width: card.marker < 0 ? base.width : card.marker
    });

    const adjusted = base;

    const overage = card.punctuality === 'late' ? mark : Rect.empty;
    const underage = card.punctuality === 'early' ? mark : Rect.empty;

    const externalLink = !!card.externalLink
        ? new Rect(base.width - 170 - 10, -16, 170, 32)
        : Rect.empty;

    const badges = [] as TagLike[];
    if (CommentCountAttr.get(card) > 0 || CommentOpenAttr.get(card)) {
        badges.push({
            id: 'comments',
            text: (CommentCountAttr.get(card) || 0).toString(),
            icon: true,
        });
    }

    const tagOpts = {
        flow: 'ltr' as const,
        textSettings: {
            fontSize: base.height < 80 ? 12 : 16,
        }
    };

    const tags = LtrTagLayout([...badges, ...Tag.sort(card.polarize(Tag))], base.inflate(new Point(-20, -10)), tagOpts);
    const label = labelLayout(card, base, base.height - tags.all.top);

    return { base, original, adjusted, overage, underage, label, externalLink, tags };
};

export type RoadmapCardLayout = ReturnType<typeof RoadmapCardLayout>;
